import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  grid-area: content;
`;

const Grid = styled.div`
  padding: 0 0.5rem 0.5rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  font-size: 0.8rem;
`;

export default ({ children, ...rest }) => (
  <Content {...rest}>
    <Grid>{children}</Grid>
  </Content>
);
